export const parseContactsList = (contactsList, selectedList, sendType, searchValue) => {
    // SendType to filter by (Email or SMS)
    const sendTypeToGet = sendType === 'email' ? 'emails' : 'phoneNumbers'

    const parsedContactsList = contactsList.map(contact => {
        const updatedContact = {
            ...contact,
            // Filter out contactDetails without value or empty value
            [sendTypeToGet]: contact[sendTypeToGet].filter(contactDetail => contactDetail.value && contactDetail.value !== '')
        }
        updatedContact[sendTypeToGet] = updatedContact[sendTypeToGet].reduce((acc, contactDetail) => {
            const parsedValue = sendTypeToGet === 'phoneNumbers' ? contactDetail.value.replaceAll(/\s/g, '').replace('+', '00') : contactDetail.value

            if (acc.find(number => number.value === parsedValue)) return acc

            acc.push({
                ...contactDetail,
                value: parsedValue,
                // Set selected if contact data is already in selectedList
                selected: !!selectedList.find(selectedContact => selectedContact.contactData === contactDetail.value)
            })
            return acc
        }, [])
        // Set selected if all contact data is selected
        updatedContact.selected = updatedContact[sendTypeToGet].every(contactDetail => contactDetail.selected)
        return updatedContact
    }).filter(contact => contact[sendTypeToGet].length >= 1)

    const filteredList = filterContactsList(parsedContactsList, searchValue, sendTypeToGet)

    // Sort list by alphabetical group objects
    const sortedGroups = filteredList.reduce((groups, contact) => {
        // Find the first non-empty name, or set default value of '-' if all names are empty
        const nameToCheck = [contact.name, contact.firstName, contact.middleName, contact.familyName].find(Boolean) || '-'
        const firstLetter = nameToCheck.substring(0, 1).toUpperCase()
        // Check if group with firstLetter exists. If not, create it and push to array
        const targetGroup = groups.find(group => group.id === firstLetter) || groups[groups.push({ id: firstLetter, contacts: [] }) - 1]
        targetGroup.contacts.push({ ...contact, nameToCheck })
        // This sorts the contacts alphabetically
        targetGroup.contacts.sort((a, b) => a.nameToCheck.localeCompare(b.nameToCheck))
        return groups
    // Sort the group objects alphabetically
    }, []).sort((a, b) => a.id.localeCompare(b.id))

    return sortedGroups
}

export const reSortAndFilterContacts = (contactsList, searchValue, sendTypeToGet) => {
    let contacts = contactsList.reduce((acc, alfabeticGroups) => {
        acc = [...acc, ...alfabeticGroups.contacts]
        return acc
    }, [])

    contacts = filterContactsList(contacts, searchValue, sendTypeToGet)

    /* Sort list by alphabetical group objects */
    const sortedGroups = contacts.reduce((groups, contact) => {
        // Find the first non-empty name, or set default value of '-' if all names are empty
        const nameToCheck = [contact.name, contact.firstName, contact.middleName, contact.familyName].find(Boolean) || '-'
        const firstLetter = nameToCheck.substring(0, 1).toUpperCase()
        // Check if group with firstLetter exists. If not, create it and push to array
        const targetGroup = groups.find(group => group.id === firstLetter) || groups[groups.push({ id: firstLetter, contacts: [] }) - 1]
        targetGroup.contacts.push({ ...contact, nameToCheck })
        // This sorts the contacts alphabetically
        targetGroup.contacts.sort((a, b) => a.nameToCheck.localeCompare(b.nameToCheck))
        return groups
    // Sort the group objects alphabetically
    }, []).sort((a, b) => a.id.localeCompare(b.id))

    return sortedGroups
}

export const filterContactsList = (contactsList, searchValue, sendTypeToGet) => {
    if (!searchValue) return contactsList
    const filteredList = contactsList.filter(contact => {
        // Filter by contact name
        const name = [contact.name, contact.firstName, contact.middleName, contact.familyName].filter(Boolean).join(' ').toLowerCase().includes(searchValue.toLowerCase())
        // Filter by email/phoneNumber
        const target = contact[sendTypeToGet].find(({ value }) => value && value.toLowerCase().includes(searchValue.toLowerCase()))
        return Boolean(name) || Boolean(target)
    })
    return filteredList
}
